export default __webpack_public_path__ + "static/media/Version (4) - Half-Blood Prince_08.e8d4d98d.jpg";